(function () {
	'use strict';
	angular.module('app.setup')
		.controller('clonePlantMetrics', clonePlantMetrics);

	clonePlantMetrics.$inject = ['$rootScope', 'siteService', 'metricsService', 'storeService'];

	function clonePlantMetrics($rootScope, siteService, metricsService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var allowedMetricTypes = ['Manual', 'Automatic'];
		vm.metrics = [];
		vm.sites = [];
		vm.users;
		vm.selectedMetrics;
		vm.selectedSites;
		vm.addSite = addSite;
		vm.removeSite = removeSite;
		vm.save = save;

		init();

		function init() {
			resetPage();
			metricsService.getMetrics('Plant', adminConfig.factory.id)
				.then(function (response) {
					if (response && response.length) {
						vm.metrics = response.filter(function (metric) {
							return allowedMetricTypes.includes(metric.metricType);
						});
					}
				});
			siteService.getSiblingSites(adminConfig.factory.id)
				.then(function (response) {
					vm.sites = response;
				});
		}

		function addSite(site) {
			siteService.getUsersForSite(site.ndx, true)
				.then(function (response) {
					_.set(vm.users, site.ndx, {
						'name': site.name,
						'users': response
					});
				});
		}

		function removeSite(site) {
			_.unset(vm.users, site.ndx);
		}

		function save() {
			var valid = true;
			// Clear Errors
			jQuery('.metrics-select').removeClass('error-border');
			jQuery('.sites-select').removeClass('error-border');
			jQuery('.user-select').removeClass('error-border');

			// Validations
			if (vm.selectedMetrics.length === 0) {
				$rootScope.$emit('toast', {
					'message': 'Please select at least one metric.',
					'success': false
				});
				jQuery('.metrics-select').addClass('error-border');
				valid = false;
			}
			if (vm.selectedSites.length === 0) {
				$rootScope.$emit('toast', {
					'message': 'Please select at least one site.',
					'success': false
				});
				jQuery('.sites-select').addClass('error-border');
				valid = false;
			}

			_.forEach(vm.users, function (value, key) {
				if (!value.selected) {
					$rootScope.$emit('toast', {
						'message': 'Please select a user for each site',
						'success': false
					});
					jQuery('.user-select').addClass('error-border');
					valid = false;
				}
			});

			// Clones
			if (valid) {
				_.forEach(vm.users, function (value, key) {
					for (var i = 0; i < vm.selectedMetrics.length; i++) {
						metricsService.cloneMetric(key, vm.selectedMetrics[i].ndx, value.selected.ndx)
							.then(function (response) {
								$rootScope.$emit('toast', {
									'message': 'Metrics Cloned',
									'success': true
								});
								resetPage();
							}, function (error) {
								$rootScope.$emit('toast', {
									'message': 'Error Cloning Metrics',
									'success': false
								});
								resetPage();
							});
					}
				});
			}
		}

		function resetPage() {
			vm.users = {};
			vm.selectedMetrics = [];
			vm.selectedSites = [];
		}

	}

})();
